
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Client from '@/models/Client';
import { LoadingOverlayHelper } from '@/helpers/LoadingOverlayHelper';

@Component({
    name: 'CmsProtectedClientsTable',
})
export default class CmsProtectedClientsTable extends Vue {
    @Prop({ type: Array, required: false, default: () => [] }) readonly userGroups!: any[];

    private search = '';
    private selectedRowKeys: string[] = [];
    private loadingOverlay = new LoadingOverlayHelper(this, {});

    private get filteredList() {
        if (!this.myData.length) {
            return [];
        }

        return this.myData.filter((client: any) => {
            return (
                client.name.toLowerCase().includes(this.search.toLowerCase()) ||
                client.userGroup.toLowerCase().includes(this.search.toLowerCase())
            );
        });
    }

    private get total(): number {
        return this.myData?.length || 0;
    }

    private get UGClients() {
        if (!this.userGroups?.length) {
            return [];
        }

        return this.userGroups
            .map((ug: any) => {
                return { client: ug.client, userGroup: ug.name };
            })
            .filter((clientData: any) => !!clientData.client);
    }

    private get myData() {
        if (!this.UGClients?.length) {
            return [];
        }

        return this.UGClients.map((data: any) => {
            return {
                id: data.client.id,
                visibleId: data.client.visibleId,
                name: data.client.name,
                userGroup: data.userGroup,
                address: data.client.address?.streetNameAndNumber,
                isBasic: data.client?.isBasic ? '✅' : '❌',
            };
        });
    }

    private get columns() {
        return [
            {
                title: this.$t('Ingenious number'),
                dataIndex: 'visibleId',
                sorter: (a: any, b: any) => a.visibleId.localeCompare(b.visibleId),
                width: '15%',
            },
            {
                title: this.$t('Name'),
                dataIndex: 'name',
                sorter: (a: any, b: any) => a.name.localeCompare(b.name),
                width: '30%',
            },
            {
                title: this.$t('User group'),
                dataIndex: 'userGroup',
                sorter: (a: any, b: any) => a.userGroup.localeCompare(b.userGroup),
                width: '15%',
            },
            {
                title: this.$t('Address'),
                dataIndex: 'address',
                sorter: (a: any, b: any) => a.address.localeCompare(b.address),
                width: '30%',
            },
            {
                title: this.$t('Is Protected'),
                dataIndex: 'isBasic',
                width: '10%',
            },
        ];
    }

    private onSelectChange(selectedRowKeys: string[]) {
        this.selectedRowKeys = selectedRowKeys;
    }

    private async setAsProtected(isProtected: boolean) {
        const promises = this.selectedRowKeys.map((clientId) => {
            return Client.setClientAsProtected(clientId, isProtected);
        });

        try {
            this.loadingOverlay.start();
            await Promise.all(promises).then(() => {
                this.selectedRowKeys = [];
            });
        } catch (error) {
            console.log('Error setting clients as protected:', error);
        } finally {
            this.loadingOverlay.stop();
        }
    }
}
